var DisclaimerModule = /** @class */ (function () {
    function DisclaimerModule() {
    }
    return DisclaimerModule;
}());
export { DisclaimerModule };
